import React, { useMemo, useRef } from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import "../../../assets/css/master.css"
import { getAllData, postUsersData, patchUsersData, deleteUserData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { formatDate, formatDateyearmonthday, formatTimeHourMinute, onlyNumeric, TimeHour } from '../../commonClass/CommonValidation';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { generatePDF } from '../../commonClass/CommonValidation'
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomSelection from '../../../customControl/CustomSelection';
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../../customControl/CustomTable';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import CommonFilter from '../../../customControl/CommonFilter';


const Sightseeingmaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [citydata, setCityData] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [activeId, setActiveId] = useState(true);
    const [sightseeingListdata, setSightseeingListdata] = useState([]);
    const [filterList, setFilterList] = useState([]);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [hoursTime, setHoursTime] = useState(null);

    const [searchvalue, setSearchValue] = useState("");
    const [searchby, setSerachBy] = useState('All');
    const [searchDisabled, setSearchDisabled] = useState(false);

    const [formError, setFormError] = useState({});

    const [allcity, setAllCity] = useState([]);
    const [citydisable, setCityDisable] = useState(false);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const VehicleName = useRef(null);
    const [allSupplierList, setAllSupplierList] = useState([]);
    const [vehicleBtnText, setVehicleBtnText] = useState("Add");
    const [isEditingVehiclePrice, setIsEditingVehiclePrice] = useState(false);
    const [editingVehicleSeqNo, setEditingVehicleSeqNo] = useState(null);
    const [formVehicle, setFormVehicle] = useState({
        SupplierId: 0,
        SupplierName: '',
        VehicleDetailId: 0,
        Price: "",
        VehicleName: "",
        VehicleCategory: "",
        VehicleType: "",
        BaggageCapacity: "",
        MaxAdultCap: "",
        FreeInfantsCap: "",
        MaxTotalCap: "",
    });

    const [vehicleListData, setVehicleListData] = useState([]);

    const [form, setForm] = useState({
        SightseeingId: 0,
        SightseeingName: '',
        LocationId: 0,
        PickupPoint: '',
        DropPoint: '',
        Hours: null,
        ItineraryDetails: '',
        DataCollection: [],
        IsActive: true,
    });

    const columns = [
        {
            name: 'Continent',
            key: 'continentName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.continentName
        },
        {
            name: 'Country',
            key: 'countryName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.countryName
        },
        {
            name: 'Region',
            key: 'regionName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.regionName
        },
        {
            name: 'State',
            key: 'stateName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.stateName
        },
        {
            name: 'City',
            key: 'city',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.city
        },
        {
            name: 'Sightseeing Name',
            key: 'sightseeingName',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.sightseeingName
        },
        {
            name: 'Pick Up Point',
            key: 'pickUpPoint',
            sortable: true,
            float: "left",
            reorder: true,
            selector: (sightseeing) => sightseeing?.pickUpPoint
        },
        {
            name: 'Drop Point',
            key: 'dropPoint',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.dropPoint
        },
        {
            name: 'Hours',
            key: 'hoursFormat',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.hoursFormat,
        },
        {
            name: 'Itinerary Details',
            key: 'itineraryDetails',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.itineraryDetails
        },
        {
            name: 'Active',
            key: 'Active',
            sortable: true,
            float: "left",
            selector: (sightseeing) => sightseeing?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            float: "left",
            selector: (sightseeing) => new Date(sightseeing?.createdDate),
            format: (sightseeing) => sightseeing?.createdDateFormat,
        },
        {
            name: 'Edit',
            selector: (sightseeing) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditView("Edit", sightseeing?.sightseeingId)}></i></button>
        },
        {
            name: 'View',
            selector: (sightseeing) => <i className="fa fa-eye" onClick={() => handleEditView("View", sightseeing?.sightseeingId)}></i>
        }
    ];

    const formatHourText = (time) => {
        if (!time) return "";
        let d = new Date(time);
        if (!isNaN(d.getTime())) {
            let h = d.getHours();
            return `${h < 10 ? '0' + h : h} hr`;
        }
        if (typeof time === 'string') {
            if (time.includes(':')) {
                let h = time.split(':')[0].trim();
                return `${h.length === 1 ? '0' + h : h} hr`;
            }
            if (!isNaN(Number(time))) {
                let h = Number(time);
                return `${h < 10 ? '0' + h : h} hr`;
            }
        }
        return `${time} hr`;
    };

    const getSightseeingDataList = async () => {
        const sightseeingListdata = await getAllData("/master/v1/getallsightseeing");
        sightseeingListdata?.data?.map((obj) => {
            obj.Active = obj?.isActive ? 'Active' : 'InActive'
            obj.createdDateFormat = obj?.createdDate ? formatDate(obj?.createdDate) : ""
            obj.hoursFormat = obj?.hours ? formatHourText(obj?.hours) : ""
            return obj;
        })
        if (sightseeingListdata?.status) {
            setSightseeingListdata(sightseeingListdata?.data ? sightseeingListdata?.data : []);
            setFilterList(sightseeingListdata?.data ? sightseeingListdata?.data : []);
        }
        else {
            setSightseeingListdata([]);
            setFilterList([]);
        }
    }

    const getCityData = async () => {
        await getAllData('/master/v1/getsightseeingcity').then((cityData) => {
            getSightseeingDataList();
            setCityData(cityData.data?.filter(IsAct => IsAct.isActive === true));
            setAllCity(cityData.data);
            dispatch(loaderActions.end());
        });
    }

    const getsuppliervehicleforsightseeing = async () => {
        const supplier = await getAllData("/master/v1/getsuppliervehicleforsightseeing")
        if (supplier?.status) {
            setAllSupplierList(supplier?.data ? supplier?.data : [])
        }
        else {
            setAllSupplierList([]);
        }
    }

    const supplierList = useMemo(() => {
        if (!form?.LocationId) return [];
        return (allSupplierList || []).filter((sup) => {
            const locId = sup?.LocationId ?? sup?.locationId ?? sup?.CityId ?? sup?.cityId;
            if (locId !== undefined && locId !== null) {
                if (Array.isArray(locId)) return locId.includes(Number(form?.LocationId));
                return Number(locId) === Number(form?.LocationId);
            }
            if (Array.isArray(sup?.SupplierVehicleDetail) && sup.SupplierVehicleDetail.length > 0) {
                return sup.SupplierVehicleDetail.some(v =>
                    Number(v?.LocationId ?? v?.locationId) === Number(form?.LocationId)
                );
            }
            return false;
        });
    }, [allSupplierList, form?.LocationId]);

    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getCityData();
            getsuppliervehicleforsightseeing();
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }, []);

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });

    }, [user])

    const cityList = citydata?.map(value => ({
        label: value?.city,
        value: value?.locationId
    }));

    const handlecity = (e) => {
        setFormError({});
        setForm((prev) => ({
            ...prev,
            LocationId: e.value
        }));
        // Reset selected supplier and vehicle when city changes
        setFormVehicle({
            SupplierId: 0,
            SupplierName: '',
            VehicleDetailId: 0,
            Price: "",
            VehicleName: "",
            VehicleCategory: "",
            VehicleType: "",
            BaggageCapacity: "",
            MaxAdultCap: "",
            FreeInfantsCap: "",
            MaxTotalCap: "",
        });
        setVehicleBtnText("Add");
        setIsEditingVehiclePrice(false);
        setEditingVehicleSeqNo(null);
        setEditDisabled(true);
    }

    const continent = citydata?.map(value => ({
        label: value?.continentName,
        value: value?.locationId
    })
    );

    const country = citydata?.map(value => ({
        label: value?.countryName,
        value: value?.locationId
    })
    );

    const region = citydata?.map(value => ({
        label: value?.regionName,
        value: value?.locationId
    })
    );

    const state = citydata?.map(value => ({
        label: value?.stateName,
        value: value?.locationId
    })
    );

    const handleSelectVehicle = (ele) => {
        setEditDisabled(true);
        setFormError({});
        setFormVehicle((vcl) => ({
            ...vcl,
            VehicleDetailId: ele?.value ? ele?.value : 0,
            VehicleName: ele?.label ? ele?.label : "",
            VehicleCategory: ele?.VehicleCategory ? ele?.VehicleCategory : (ele?.vehicleCategory || ""),
            VehicleType: ele?.VehicleType ? ele?.VehicleType : (ele?.vehicleType || ""),
            BaggageCapacity: ele?.BaggageCapacity ? ele?.BaggageCapacity : (ele?.baggageCapacity ?? ""),
            MaxAdultCap: ele?.MaxAdultCap ?? ele?.maxAdultCap ?? ele?.MaxAdult ?? ele?.maxAdult ?? "",
            FreeInfantsCap: ele?.FreeInfantsCap ?? ele?.freeInfantsCap ?? ele?.FreeInfants ?? ele?.freeInfants ?? "",
            MaxTotalCap: ele?.MaxTotalCap ?? ele?.maxTotalCap ?? ele?.MaxTotal ?? ele?.maxTotal ?? "",
        }))
    }

    const handleChangePrice = (name, value) => {
        setEditDisabled(true);
        setFormError({});
        setFormVehicle((vcl) => ({ ...vcl, [name]: value }))
    }

    const validateVehicleData = () => {
        let status = true;
        let error = {};
        if (formVehicle?.SupplierId === 0 || formVehicle?.SupplierId === null) {
            error.SupplierId = "Please select Supplier Name";
            status = false;
        }

        if (formVehicle?.SupplierId > 0 && (formVehicle?.VehicleDetailId === 0 || formVehicle?.VehicleDetailId === null)) {
            error.VehicleName = "Please select Vehicle Name";
            status = false;
        }
        if (formVehicle?.SupplierId > 0 && (formVehicle?.Price === 0 || formVehicle?.Price === null || formVehicle?.Price === "")) {
            error.Price = "Please enter Price";
            status = false;
        }
        if (formVehicle?.Price && String(formVehicle?.Price).length > 7) {
            error.Price = "Maximum Price length allowed is 7 digits";
            status = false;
        }

        setFormError(error);
        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0]
            if (id === "VehicleName") {
                VehicleName.current?.focus();
            }
            else {
                document.getElementById(id)?.focus();
            }
        }
        return status;
    }

    const checkVehicleDuplicateError = () => {
        let status = true;
        let error = {};
        const checkDuplicate = vehicleListData?.filter((fil) => fil?.VehicleDetailId === formVehicle?.VehicleDetailId && fil?.SupplierId === formVehicle?.SupplierId)?.length
        if (checkDuplicate > 0) {
            error.VehicleDuplicate = 'You can not enter duplicate Vehicle'
            status = false;
        }
        setFormError(error);
        return status;
    }

    const vehicleDetailList = useMemo(() => {
        return supplierList?.find((prev) => prev.value === formVehicle?.SupplierId)?.SupplierVehicleDetail || [];
    }, [supplierList, formVehicle?.SupplierId])

    const handleAddOrUpdateVehicle = (e) => {
        e.preventDefault();
        if (isEditingVehiclePrice) {
            let error = {};
            if (!formVehicle?.Price || formVehicle?.Price === "" || Number(formVehicle?.Price) === 0) {
                error.Price = "Please enter Price";
                setFormError(error);
                document.getElementById("Price")?.focus();
                return;
            }
            if (formVehicle?.Price && String(formVehicle?.Price).length > 7) {
                error.Price = "Maximum Price length allowed is 7 digits";
                setFormError(error);
                document.getElementById("Price")?.focus();
                return;
            }
            setVehicleListData((listData) =>
                listData.map((item) =>
                    item.SeqNo === editingVehicleSeqNo
                        ? { ...item, Price: formVehicle.Price }
                        : item
                )
            );
            handleCancelEditVehiclePrice();
            setEditDisabled(true);
        } else {
            if (validateVehicleData() && checkVehicleDuplicateError()) {
                setVehicleListData((listData) => ([
                    ...listData,
                    {
                        SeqNo: listData?.length + 1,
                        SupplierId: formVehicle?.SupplierId,
                        SupplierName: formVehicle?.SupplierName,
                        VehicleDetailId: formVehicle?.VehicleDetailId,
                        Price: formVehicle?.Price,
                        VehicleName: formVehicle?.VehicleName,
                        VehicleCategory: formVehicle?.VehicleCategory,
                        VehicleType: formVehicle?.VehicleType,
                        BaggageCapacity: formVehicle?.BaggageCapacity,
                        MaxAdultCap: formVehicle?.MaxAdultCap,
                        FreeInfantsCap: formVehicle?.FreeInfantsCap,
                        MaxTotalCap: formVehicle?.MaxTotalCap,
                    }
                ]))
                setFormVehicle({
                    SupplierId: 0,
                    SupplierName: '',
                    VehicleDetailId: 0,
                    Price: "",
                    VehicleName: "",
                    VehicleCategory: "",
                    VehicleType: "",
                    BaggageCapacity: "",
                    MaxAdultCap: "",
                    FreeInfantsCap: "",
                    MaxTotalCap: "",
                });
                setEditDisabled(true);
            }
        }
    }

    const handleEditVehiclePrice = (obj) => {
        setEditDisabled(true);
        setFormError({});
        setIsEditingVehiclePrice(true);
        setEditingVehicleSeqNo(obj?.SeqNo);
        setVehicleBtnText("Update");
        setFormVehicle({
            SupplierId: obj?.SupplierId,
            SupplierName: obj?.SupplierName,
            VehicleDetailId: obj?.VehicleDetailId,
            Price: obj?.Price ? String(obj?.Price) : "",
            VehicleName: obj?.VehicleName,
            VehicleCategory: obj?.VehicleCategory,
            VehicleType: obj?.VehicleType,
            BaggageCapacity: obj?.BaggageCapacity,
            MaxAdultCap: obj?.MaxAdultCap ?? "",
            FreeInfantsCap: obj?.FreeInfantsCap ?? "",
            MaxTotalCap: obj?.MaxTotalCap ?? "",
        });
    }

    const handleCancelEditVehiclePrice = () => {
        setIsEditingVehiclePrice(false);
        setEditingVehicleSeqNo(null);
        setVehicleBtnText("Add");
        setFormVehicle({
            SupplierId: 0,
            SupplierName: '',
            VehicleDetailId: 0,
            Price: "",
            VehicleName: "",
            VehicleCategory: "",
            VehicleType: "",
            BaggageCapacity: "",
            MaxAdultCap: "",
            FreeInfantsCap: "",
            MaxTotalCap: "",
        });
    }

    const handleRemoveVehicle = async (row) => {
        setEditDisabled(true);
        setFormError({});
        if (editingVehicleSeqNo === row?.SeqNo) {
            handleCancelEditVehiclePrice();
        }

        const vehicleDetailId = row?.VehicleDetailId;
        if (!vehicleDetailId) {
            setVehicleListData(prev => prev.filter(fil => fil.SeqNo !== row.SeqNo).map((obj, idx) => ({ ...obj, SeqNo: idx + 1 })));
            return;
        }

        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            dispatch(loaderActions.start());
            let res = await getAllData(`/master/v1/removevehicle?VehicleDetailId=${vehicleDetailId}`);
            if (!res || res.status === undefined) {
                res = await deleteUserData(`/master/v1/removevehicle?VehicleDetailId=${vehicleDetailId}`);
            }
            dispatch(loaderActions.end());

            if (res?.status) {
                setVehicleListData(prev =>
                    prev.filter(fil => fil.SeqNo !== row.SeqNo).map((obj, index) => ({ ...obj, SeqNo: index + 1 }))
                );
                if (res?.message) {
                    dispatch({ type: 'ALERTING', message: res.message });
                }
            } else {
                dispatch({ type: 'ALERTING', message: res?.message || 'Cannot remove vehicle' });
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const OnChangeDropDown = (name, val) => {
        setFormError({})
        setEditDisabled(true);
        setFormVehicle((vcl) => ({
            ...vcl,
            SupplierId: val?.value,
            SupplierName: val?.label,
            Price: '',
            BaggageCapacity: "",
            VehicleDetailId: 0,
            VehicleName: "",
            VehicleCategory: "",
            VehicleType: "",
            MaxAdultCap: "",
            FreeInfantsCap: "",
            MaxTotalCap: "",
        }))
    }

    const onChange = (e) => {
        setFormError({});
        var result;
        if ([e.target.name][0] === 'Price') {
            result = onlyNumeric(e.target.value)
        }
        else {
            result = e.target.value;
        }
        setForm({ ...form, [e.target.name]: result });
        setEditDisabled(true);
    }

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = e
            setActiveId(!activeId)
            setFormError({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormError({});
            form.IsActive = !activeId
            setActiveId(!activeId)
            setEditDisabled(true);
        }
        setModalShow(false);
    }

    const HoursRef = useRef(null);
    const CityError = useRef(null);

    const validateData = () => {
        let status = true;
        let error = {};

        if (form?.LocationId <= 0) {
            error.CityError = "Please select city";
            status = false;
        }
        if (form.SightseeingName?.trim()?.length === 0) {
            error.SightseeingName = "Please enter Sightseeing Name";
            status = false;
        }
        if (form.SightseeingName && form.SightseeingName?.trim()?.length > 150) {
            error.SightseeingName = "Maximum length allowed for Sightseeing Name is 150 characters";
            status = false;
        }
        if (form.PickupPoint?.trim()?.length === 0) {
            error.PickupPoint = "Please enter PickUp Point";
            status = false;
        }
        if (form.PickupPoint && form.PickupPoint?.trim()?.length > 100) {
            error.PickupPoint = "Maximum length allowed for Pickup Point is 100 characters";
            status = false;
        }
        if (form.DropPoint?.trim()?.length === 0) {
            error.DropPoint = "Please enter Drop Point";
            status = false;
        }
        if (form.DropPoint && form.DropPoint?.trim()?.length > 100) {
            error.DropPoint = "Maximum length allowed for Drop Point is 100 characters";
            status = false;
        }
        if (form.ItineraryDetails?.trim()?.length === 0) {
            error.ItineraryDetails = "Please enter Itinerary Details";
            status = false;
        }
        if (form.ItineraryDetails && form.ItineraryDetails?.trim()?.length > 1000) {
            error.ItineraryDetails = "Maximum length allowed for Itinerary Details is 1000 characters";
            status = false;
        }
        if (vehicleListData?.length === 0) {
            error.VehicleDetailError = "Please enter at least one vehicle details"
            status = false;
        }
        setFormError(error);
        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0];
            if (id === "CityError") {
                CityError.current?.focus();
            }
            else {
                document.getElementById(id)?.focus();
            }
        }
        return status;
    }

    const checkDuplicateError = () => {
        let status = true;
        let error = {};

        const checkDuplicate = sightseeingListdata?.filter(issec =>
            (buttonaddeditText === 'Add' ? true : issec?.sightseeingId !== form?.SightseeingId) &&
            issec?.sightseeingName?.trim()?.toLowerCase() === form?.SightseeingName?.trim()?.toLowerCase() &&
            issec?.pickUpPoint?.trim()?.toLowerCase() === form?.PickupPoint?.trim()?.toLowerCase() &&
            issec?.dropPoint?.trim()?.toLowerCase() === form?.DropPoint?.trim()?.toLowerCase() &&
            issec?.locationId === form?.LocationId)?.length

        if (checkDuplicate > 0) {
            error.SightseeingDuplicate = 'This Sightseeing already exists for the same city, pick up point and drop point.'
            status = false;
        }
        setFormError(error);
        return status;
    }

    const handleAddClick = async () => {
        if (validateData() && checkDuplicateError()) {
            form.IsActive = activeId;
            form.SightseeingName = form?.SightseeingName?.trim();
            form.PickupPoint = form?.PickupPoint?.trim();
            form.DropPoint = form?.DropPoint?.trim();
            form.ItineraryDetails = form?.ItineraryDetails?.trim();
            form.DataCollection = vehicleListData?.map((obj) => ({ SupplierId: obj?.SupplierId, VehicleDetailId: Number(obj?.VehicleDetailId), Price: Number(obj?.Price) }));
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const SightseeingData = await postUsersData("/master/v1/insertorupdatesightseeing", form)
                if (SightseeingData?.status) {
                    dispatch({ type: 'ALERTING', message: SightseeingData?.message })
                    clear();
                    getSightseeingDataList();
                }
                else {
                    dispatch({ type: 'ALERTING', message: SightseeingData?.message })
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    };

    const handleEditView = (type, id) => {
        setDisabled(type === "Edit" ? false : true);
        setButtonAddEditText(type === "Edit" ? "Update" : "Add");
        setEditDisabled(false);
        setSearchDisabled(true);
        setCityDisable(true);
        RetriveData(id, type);
    }

    const RetriveData = (id, type) => {
        setFormError({});
        sightseeingListdata.filter(objid => objid.sightseeingId === id)?.map(obj => {
            setForm({
                ...form,
                SightseeingId: obj.sightseeingId,
                SightseeingName: obj.sightseeingName,
                LocationId: obj.locationId,
                PickupPoint: obj.pickUpPoint,
                DropPoint: obj.dropPoint,
                Hours: obj.hours,
                ItineraryDetails: obj.itineraryDetails,
                IsActive: obj.isActive,
                VehicleTypeId: obj.vehicleTypeId,
            })
            let allcitylist = allcity?.filter(IsAct => IsAct.isActive === true);
            setCityData(allcity?.filter(IsAct => IsAct.isActive === true));

            if (type === "Edit" && !allcitylist?.find(IsCity => IsCity.locationId === obj.locationId)) {
                setCityData((prvCityData) => prvCityData?.length > 0 ? [...prvCityData, allcity?.find(isCity => isCity.locationId === obj.locationId)] : [])
            }
            setActiveId(obj.isActive);
            setHoursTime(obj.hours ? dayjs(obj.hours) : null)
            obj?.dataCollection?.map((coll, index) => {
                coll.SupplierId = coll.supplierId
                coll.SupplierName = coll.supplierName
                coll.VehicleDetailId = coll.vehicleDetailId
                coll.VehicleName = coll.vehicleName
                coll.VehicleCategory = coll.vehicleCategory
                coll.VehicleType = coll.vehicleType
                coll.BaggageCapacity = coll.baggageCapacity
                coll.Price = coll.price
                coll.MaxAdultCap = coll.maxAdultCap ?? coll.MaxAdultCap ?? coll.maxAdult ?? coll.MaxAdult ?? ""
                coll.FreeInfantsCap = coll.freeInfantsCap ?? coll.FreeInfantsCap ?? coll.freeInfants ?? coll.FreeInfants ?? ""
                coll.MaxTotalCap = coll.maxTotalCap ?? coll.MaxTotalCap ?? coll.maxTotal ?? coll.MaxTotal ?? ""
                coll.SeqNo = index + 1

                return coll;
            })
            setVehicleListData(obj?.dataCollection ? obj?.dataCollection : [])
        });
    }

    const clear = () => {
        setFormError({});
        setForm((form) => ({
            ...form,
            SightseeingId: 0,
            SightseeingName: '',
            PickupPoint: '',
            DropPoint: '',
            Hours: null,
            ItineraryDetails: '',
            IsActive: true,
            LocationId: 0,
            DataCollection: []
        }))
        getSightseeingDataList();
        setActiveId(true);
        setDisabled(false);
        setEditDisabled(true);
        setSearchDisabled(false);
        setSerachBy('All');
        setSearchValue('');
        setButtonAddEditText('Add');
        setHoursTime(null);
        setCityDisable(false);

        setVehicleListData([]);
        setFormVehicle({
            SupplierId: 0,
            SupplierName: '',
            VehicleDetailId: 0,
            Price: "",
            VehicleName: "",
            VehicleCategory: "",
            VehicleType: "",
            BaggageCapacity: "",
            MaxAdultCap: "",
            FreeInfantsCap: "",
            MaxTotalCap: "",
        });
        setVehicleBtnText("Add");
        setIsEditingVehiclePrice(false);
        setEditingVehicleSeqNo(null);
    }

    function PdfExport() {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = sightseeingListdata?.map((obj) => keys?.map((key) => obj[key]))
        generatePDF(pdfColumns, rows, "SightseeingMaster", "Sightseeing Master", "l")
    }
    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, sightseeingListdata, "SightseeingMaster", "SightseeingMaster.xls");
    }

    //#region time format
    const handleonchangeofTime = (name, times) => {
        setEditDisabled(true);
        setFormError({});
        setHoursTime(times);
        setForm((form) => ({ ...form, [name]: times ? `${formatDateyearmonthday(new Date())}T${TimeHour(times)}:00:00` : times }));
    }
    //#endregion time format
    return (
        <>

            <div className="container-fluid mt-4 heading_color">
                <h3>Sightseeing Master</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                {formError?.SightseeingDuplicate && <p className='text-danger text-start mb-0'>{formError?.SightseeingDuplicate}</p>}
                                <div className='col-lg-2 col-sm-6 mx-lg-auto ms-lg-0'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Continent</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={continent?.find(({ value }) => value === form?.LocationId)}
                                            options={continent}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Country</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={country?.find(({ value }) => value === form?.LocationId)}
                                            options={country}
                                        />
                                    </div>

                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Region</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={region?.find(({ value }) => value === form?.LocationId)}
                                            options={region}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">State</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <Select className="dropdown select_dropdown"
                                            isDisabled
                                            value={state?.find(({ value }) => value === form?.LocationId)}
                                            options={state}
                                        />
                                    </div>
                                </div>
                                <div className='col-lg-2 col-sm-6 mx-lg-auto me-lg-0'>
                                    <div className="col-lg-12 col-md-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">City</label>
                                    </div>
                                    <div className="col-lg-12 mb-1 col-md-12">
                                        <CustomSelection
                                            selId="CityError"
                                            selRef={CityError}
                                            datalist={cityList}
                                            fieldid={form?.LocationId}
                                            SelectionChange={handlecity}
                                            isdisable={disabled || citydisable}
                                            isactivedisable={citydisable}
                                            issearchable={true}
                                        />
                                        {formError?.CityError && <p className='text-danger mb-0'>{formError?.CityError}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-1 mt-4 col-lg-11 mx-lg-5">
                        <div className='row'>
                            <div className='col-lg-12 col-sm-12 '>
                                <div className='row'>

                                    <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Sightseeing Name</label>
                                    </div>
                                    <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                        <textarea type="text"
                                            id="SightseeingName"
                                            className="form-control enquiry_boder py-2 mx-auto"
                                            name="SightseeingName"
                                            value={form.SightseeingName}
                                            onChange={onChange}
                                            disabled={disabled ? true : false}
                                            placeholder='Sightseeing Name'
                                        // maxLength={5000}
                                        />
                                        {formError?.SightseeingName && <p className='text-danger mb-0'>{formError?.SightseeingName}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Pick Up Point</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input type="text"
                                            id="PickupPoint"
                                            className="form-control"
                                            name='PickupPoint'
                                            value={form.PickupPoint}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Pick Up Point'
                                        />
                                        {formError?.PickupPoint && <p className='text-danger mb-0'>{formError?.PickupPoint}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Drop Point</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <input type="text"
                                            id="DropPoint"
                                            className="form-control"
                                            name="DropPoint"
                                            value={form.DropPoint}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Drop Point'
                                        />
                                        {formError?.DropPoint && <p className='text-danger mb-0'>{formError?.DropPoint}</p>}
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label">Hours</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <TimePicker
                                            ref={HoursRef}
                                            id='Hours'
                                            className='form-control defo_border'
                                            disabled={disabled ? true : false}
                                            placeholder='--'
                                            format='HH'
                                            value={hoursTime}
                                            needConfirm={false}
                                            disabledTime={() => ({
                                                disabledMinutes: () => {
                                                    // Disable every minute except 0
                                                    return Array.from({ length: 60 }, (_, i) => i).filter(i => i !== 0);
                                                }
                                            })}
                                            showNow={false}
                                            onChange={(e) => handleonchangeofTime("Hours", e)}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className='col-lg-6 col-sm-6 '>
                                <div className='row'>
                                    <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                                    </div>
                                    <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                        <Switch
                                            onChange={handleisActive}
                                            checked={activeId}
                                            className="react-switch"
                                            disabled={disabled ? true : false}
                                        // disabled={disabled ? true : false}
                                        />
                                    </div>
                                    {/* <div className=" col-auto col-lg-4"> */}
                                    <ConfirmationModal
                                        show={modalShow}
                                        onHide={() => setModalShow(false)}
                                        noconfirm={() => handleConfirmation(false)}
                                        yesconfirm={() => handleConfirmation(true)}
                                    />

                                    {/* </div> */}
                                </div>
                            </div>
                            <div className='col-lg-12 col-sm-12 '>
                                <div className='row'>
                                    <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Itinerary Details</label>
                                    </div>
                                    {/* <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1"> */}
                                    <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                                        <textarea type="text"
                                            id="ItineraryDetails"
                                            className="form-control enquiry_boder py-2 mx-auto"
                                            name="ItineraryDetails"
                                            value={form.ItineraryDetails}
                                            disabled={disabled ? true : false}
                                            onChange={onChange}
                                            placeholder='Itinerary Details'
                                        // maxLength={5000}
                                        />
                                        {formError?.ItineraryDetails && <p className='text-danger mb-0'>{formError?.ItineraryDetails}</p>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <div className="col-lg-12 mx-1">
                            <label htmlFor="inputPassword" className=" col-form-label fw-bolder">Vehicle Details</label>
                        </div>
                        <div className="col-lg-12">
                            <div className="mb-3 row mx-1 form_border py-3">
                                <div className='col-12 '>
                                    {formError?.VehicleDetailError && <p className="text-danger text-center"> {formError?.VehicleDetailError} </p>}
                                    {formError?.VehicleDuplicate && <p className="text-danger text-center"> {formError?.VehicleDuplicate} </p>}

                                    {/* Row 1: Select Supplier, Vehicle Name, Price */}
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <label htmlFor="SupplierIds" className="col-form-label required">Select Supplier</label>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <Select className="dropdown select_dropdown"
                                                        id="SupplierIds"
                                                        name='SupplierId'
                                                        inputId='SupplierId'
                                                        options={supplierList}
                                                        value={supplierList?.filter((fil) =>
                                                            fil?.value === formVehicle?.SupplierId
                                                        )}
                                                        onChange={(e) => OnChangeDropDown('SupplierId', e)}
                                                        isDisabled={disabled || isEditingVehiclePrice || !form?.LocationId}
                                                        placeholder="Select Supplier"
                                                    />
                                                    {formError?.SupplierId && <p className="text-danger mb-0"> {formError?.SupplierId} </p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <label htmlFor="VehicleName" className="col-form-label required">Vehicle Name</label>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <Select className="dropdown select_dropdown"
                                                        id="VehicleName"
                                                        ref={VehicleName}
                                                        name='VehicleName'
                                                        options={vehicleDetailList}
                                                        value={vehicleDetailList?.filter((fil) =>
                                                            fil?.value === formVehicle?.VehicleDetailId
                                                        )}
                                                        onChange={(e) => handleSelectVehicle(e)}
                                                        isDisabled={disabled || isEditingVehiclePrice || formVehicle?.SupplierId <= 0}
                                                        placeholder="Select Vehicle"
                                                    />
                                                    {formError?.VehicleName && <p className="text-danger mb-0"> {formError?.VehicleName} </p>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-12">
                                                    <label htmlFor="Price" className="col-form-label required">Price</label>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="Price"
                                                        id="Price"
                                                        value={formVehicle?.Price}
                                                        placeholder='Price per vehicle (INR)'
                                                        maxLength={7}
                                                        onChange={(e) => {
                                                            const val = onlyNumeric(e.target.value);
                                                            if (val?.length <= 7) {
                                                                handleChangePrice(e.target.name, val);
                                                            }
                                                        }}
                                                        disabled={disabled || (!isEditingVehiclePrice && formVehicle?.SupplierId <= 0)}
                                                    />
                                                    {formError?.Price && <p className="text-danger mb-0"> {formError?.Price} </p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 2: Max Adult (cap), Free Infants (cap), Max Total (cap) */}
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <label htmlFor="MaxAdultCap" className="col-form-label">Max Adult (cap)</label>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="MaxAdultCap"
                                                        id="MaxAdultCap"
                                                        placeholder='Max Adult (cap)'
                                                        value={formVehicle?.MaxAdultCap ?? ""}
                                                        disabled
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <label htmlFor="FreeInfantsCap" className="col-form-label">Free Infants (cap)</label>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="FreeInfantsCap"
                                                        id="FreeInfantsCap"
                                                        placeholder='Free Infants (cap)'
                                                        value={formVehicle?.FreeInfantsCap ?? ""}
                                                        disabled
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-12">
                                                    <label htmlFor="MaxTotalCap" className="col-form-label">
                                                        Max Total (cap)
                                                        <span className="d-block text-muted" style={{ fontSize: '0.8rem', fontWeight: 'normal' }}>(Adult + Child)</span>
                                                    </label>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="MaxTotalCap"
                                                        id="MaxTotalCap"
                                                        placeholder='Max Total (cap)'
                                                        value={formVehicle?.MaxTotalCap ?? ""}
                                                        disabled
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Row 3: Vehicle Category, Vehicle Type, Baggage Capacity */}
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <label htmlFor="VehicleCategory" className="col-form-label">Vehicle Category</label>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="VehicleCategory"
                                                        id="VehicleCategory"
                                                        placeholder='Vehicle Category'
                                                        value={formVehicle?.VehicleCategory ?? ""}
                                                        disabled
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <label htmlFor="VehicleType" className="col-form-label">Vehicle Type</label>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="VehicleType"
                                                        id="VehicleType"
                                                        placeholder='Vehicle Type'
                                                        value={formVehicle?.VehicleType ?? ""}
                                                        disabled
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-12 mb-2">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-12">
                                                    <label htmlFor="BaggageCapacity" className="col-form-label">Baggage Capacity</label>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-12">
                                                    <input
                                                        type="text"
                                                        className='form-control'
                                                        name="BaggageCapacity"
                                                        id="BaggageCapacity"
                                                        placeholder='Baggage Capacity'
                                                        value={formVehicle?.BaggageCapacity ?? ""}
                                                        disabled
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 text-center">
                                        <button
                                            className="btn btn-primary mx-1"
                                            type="button"
                                            id='addvehicle'
                                            onClick={(e) => handleAddOrUpdateVehicle(e)}
                                            disabled={disabled}
                                        >
                                            {vehicleBtnText}
                                        </button>
                                        {isEditingVehiclePrice && (
                                            <button
                                                className="btn btn-secondary mx-1"
                                                type="button"
                                                id='cancelvehicle'
                                                onClick={handleCancelEditVehiclePrice}
                                                disabled={disabled}
                                            >
                                                Cancel
                                            </button>
                                        )}
                                    </div>

                                    <div className='mb-1 col-lg-12 col-md-12 mt-3 overflow-auto'>
                                        <table id="data" className="table table-hover" >
                                            <thead>
                                                <tr>
                                                    <th> Supplier Name </th>
                                                    <th> Vehicle Name </th>
                                                    <th> Price </th>
                                                    <th> Max Adult </th>
                                                    <th> Max Total </th>
                                                    <th> Free Infants </th>
                                                    <th> Vehicle Category </th>
                                                    <th> Vehicle Type </th>
                                                    <th> Baggage Capacity </th>
                                                    <th> Edit Price </th>
                                                    <th> Remove </th>
                                                </tr>
                                            </thead>
                                            <tbody id="location-data">
                                                {vehicleListData?.map((obj) => {
                                                    return (
                                                        <tr className="ReactTable" key={obj?.SeqNo || obj?.VehicleDetailId}>
                                                            <td>{obj.SupplierName}</td>
                                                            <td>{obj.VehicleName}</td>
                                                            <td>{obj.Price}</td>
                                                            <td>{obj.MaxAdultCap ?? obj.MaxAdult ?? "-"}</td>
                                                            <td>{obj.MaxTotalCap ?? obj.MaxTotal ?? "-"}</td>
                                                            <td>{obj.FreeInfantsCap ?? obj.FreeInfants ?? "-"}</td>
                                                            <td>{obj.VehicleCategory}</td>
                                                            <td>{obj.VehicleType}</td>
                                                            <td>{obj.BaggageCapacity}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary mx-1"
                                                                    onClick={() => handleEditVehiclePrice(obj)}
                                                                    disabled={disabled}
                                                                >
                                                                    Edit Price
                                                                </button>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveVehicle(obj)}
                                                                    disabled={disabled}
                                                                    className="btn btn-primary mx-1"
                                                                    id="btnRemove"
                                                                >
                                                                    Remove
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={clear}>Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filterList}
                        searchDisabled={searchDisabled}
                        getdata={getSightseeingDataList}
                        setlistdata={setSightseeingListdata}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={sightseeingListdata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />

                </form>
            </div>
        </>
    )
}

export default Sightseeingmaster
